module.exports = __webpack_public_path__ + "img/linkedin.77242090.svg";